export const LOAD_CATEGORY_NAV_DATA_ASYNC = 'LOAD_CATEGORY_NAV_DATA_ASYNC';
export const LOAD_CATEGORY_NAV_DATA = 'LOAD_CATEGORY_NAV_DATA';
export const LOAD_CATEGORY_NAV_DATA_FAILED = 'LOAD_CATEGORY_NAV_DATA_FAILED';

export const CATEGORY_SELECTED = 'CATEGORY_SELECTED';
export const CATEGORY_NAV_URL_UPDATE = 'CATEGORY_NAV_URL_UPDATE';
export const RESET_CATEGORY_NAV_DATA = 'RESET_CATEGORY_NAV_DATA';